import * as R from 'ramda';

export default function uniqueProductNameDirective(
  $q,
  vmDataService
  // vmSharedModelService
) {
  return {
    restrict: 'A',
    require: ['^form', '?ngModel'],
    link,
  };

  function link(scope, el, attrs, ctrls) {
    const vendorId = attrs.vendorId || -1;
    const productId = attrs.productId || -1;
    // const form = ctrls[0];
    const ctrl = ctrls[1];

    ctrl.$asyncValidators.uniqueProductName = (modelValue) => {
      // form.$setPristine();

      if (ctrl.$isEmpty(modelValue)) {
        // Consider empty model valid. This is probably the view's initial load.
        return $q.resolve();
      }

      const name = _getName(modelValue);

      if (!name) {
        // Nothing to check, move along... move along...
        return $q.resolve();
      }

      const def = $q.defer();

      // We have a name, so see if it exists
      vmDataService.checkProductExists(vendorId, productId, name).then((response) => {
      // checkProductNameExists(vendorId, productId, name)
        const isExists = response.data.result;

        if (!isExists) {
          def.resolve();
        } else {
          def.reject();
        }
      }).catch(() => def.reject());

      return def.promise;
    };
  }

  function _getName(modelValue) {
    switch (R.type(modelValue)) {
      case 'Object':
        return modelValue.name;
      default:
        // Assume modelValue is a string
        return modelValue;
    }
  }
}

export const name = 'uniqueProductName';

uniqueProductNameDirective.$inject = [
  '$q',
  'vmDataService'
  // 'vmSharedModelService'
];
